/**
 * TanStack Query hooks for `campaign-carrier-targeting`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignCarrierTargetingQueryKeys,
	type CreateCampaignCarrierTargetingBody,
	type ListCampaignCarrierTargetingResponse,
	type CampaignCarrierTargetingRow,
} from "./api";

export function useCampaignCarrierTargetingList(): UseQueryResult<ListCampaignCarrierTargetingResponse, Error> {
	return useQuery({
		queryKey: campaignCarrierTargetingQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignCarrierTargetingCreate(): UseMutationResult<CampaignCarrierTargetingRow, Error, CreateCampaignCarrierTargetingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignCarrierTargetingQueryKeys.all });
		},
	});
}

export function useCampaignCarrierTargetingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignCarrierTargetingQueryKeys.all });
		},
	});
}
